module.exports = __webpack_public_path__ + "media/customizations/elevon/logo-e1b1ca1fdc2e917a92dfb08c6a01acf0.png";